import {FC, useEffect} from "react";
import {useUser} from "../../../store/userContext.ts";
import {Route, Routes, useNavigate} from "react-router";
import CreateSitePage from "./CreateSitePage.tsx";
import SiteIndex from "./site";

const RedirectToSite: FC = () => {
    const user = useUser();
    const navigate = useNavigate();

    useEffect(() => {
        if (!user) {
            return;
        }

        // Check onboarding first - if user hasn't completed onboarding, redirect there
        if (!user.name) {
            navigate("/u/onboarding")
            return;
        }

        // Only check sites after confirming user has completed onboarding
        if (user.sites.length === 0) {
            navigate("/u/dashboard/create-site")
        } else {
            navigate(`/u/dashboard/site/${user.sites[0].siteId}`)
        }
    }, [user, navigate]);

    return undefined;
}

const DashboardIndex: FC = () => {
    return <Routes>
        <Route path="/" element={<RedirectToSite />} />
        <Route path="/create-site" element={<CreateSitePage />} />
        <Route path="/site/:siteId/*" element={<SiteIndex />} />
        <Route path="*" element={<RedirectToSite />} />
    </Routes>
}

export default DashboardIndex;